/* Mark's Outdoors scroll-expansion hero — vanilla port of
   scroll-expansion-hero.tsx. The page stays pinned while wheel/touch/keyboard
   input expands the video from a pill to full viewport; the split headline
   exits sideways; the mission block fades in 350ms after full expansion.
   Reduced motion: the video never mounts (still poster stays). */
(function () {
  'use strict';

  var root = document.querySelector('[data-mo-hero]');
  if (!root) return;

  document.body.classList.add('mo-has-hero');

  var bgLayer = root.querySelector('[data-hero-bg]');
  var mediaBox = root.querySelector('[data-hero-media]');
  var overlay = root.querySelector('[data-hero-overlay]');
  var headline = root.querySelector('[data-hero-headline]');
  var lineTop = root.querySelector('[data-hero-line-top]');
  var lineBottom = root.querySelector('[data-hero-line-bottom]');
  var mission = root.querySelector('[data-hero-mission]');
  var scrollHint = root.querySelector('[data-hero-scroll-hint]');
  var videoTemplate = root.querySelector('template[data-hero-video]');

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var progress = 0;
  var fullyExpanded = false;
  var missionTimer = null;
  var touchStartY = 0;

  /* Video mounts lazily after idle; never under reduced motion. */
  if (!reducedMotion && videoTemplate) {
    var mountVideo = function () {
      var frag = videoTemplate.content.cloneNode(true);
      var video = frag.querySelector('video');
      video.addEventListener('canplay', function () {
        video.style.opacity = '1';
      });
      mediaBox.insertBefore(frag, overlay);
      video.play().catch(function () {});
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(mountVideo, { timeout: 2500 });
    } else {
      window.setTimeout(mountVideo, 1200);
    }
  }

  function isMobile() {
    return window.innerWidth < 768;
  }

  function render() {
    var mob = isMobile();
    /* Hidden on load (opacity 0), then appears + grows the moment the user
       scrolls. Grows to the same full size as before (mobile 900x600,
       desktop 1520x780). */
    var wStart = mob ? 90 : 110;
    var hStart = mob ? 118 : 145;
    var wEnd = mob ? 900 : 1520;
    var hEnd = mob ? 600 : 780;
    var w = wStart + progress * (wEnd - wStart);
    var h = hStart + progress * (hEnd - hStart);
    mediaBox.style.width = w + 'px';
    mediaBox.style.height = h + 'px';
    /* Invisible at progress 0; fades in fast on the first bit of scroll. */
    mediaBox.style.opacity = Math.min(1, progress * 15);
    bgLayer.style.opacity = Math.max(0, 1 - progress * 1.8);
    overlay.style.opacity = Math.max(0, 0.55 - progress * 0.4);
    headline.style.opacity = Math.max(0, 1 - progress * 1.4);
    var off = progress * 55;
    lineTop.style.transform = 'translateX(-' + off + 'vw)';
    lineBottom.style.transform = 'translateX(' + off + 'vw)';
    if (scrollHint) scrollHint.style.opacity = Math.max(0, 1 - progress * 3);
  }

  function showMission() {
    mission.classList.add('is-shown');
  }
  function hideMission() {
    mission.classList.remove('is-shown');
  }

  function setExpanded(next) {
    if (next === fullyExpanded) return;
    fullyExpanded = next;
    root.classList.toggle('is-expanded', next);
    if (missionTimer) window.clearTimeout(missionTimer);
    if (next) {
      missionTimer = window.setTimeout(showMission, 350);
    } else {
      hideMission();
    }
  }

  function updateProgress(next) {
    progress = Math.min(Math.max(next, 0), 1);
    render();
    if (progress >= 1) {
      setExpanded(true);
    } else if (progress < 0.95) {
      setExpanded(false);
    }
  }

  function onWheel(e) {
    if (fullyExpanded && e.deltaY < 0 && window.scrollY <= 5) {
      setExpanded(false);
      e.preventDefault();
    } else if (!fullyExpanded) {
      e.preventDefault();
      updateProgress(progress + e.deltaY * 0.0009);
    }
  }

  function onTouchStart(e) {
    touchStartY = e.touches[0].clientY;
  }
  function onTouchMove(e) {
    if (!touchStartY) return;
    var delta = touchStartY - e.touches[0].clientY;
    if (fullyExpanded && delta < -20 && window.scrollY <= 5) {
      setExpanded(false);
      e.preventDefault();
    } else if (!fullyExpanded) {
      e.preventDefault();
      var factor = delta < 0 ? 0.008 : 0.005;
      updateProgress(progress + delta * factor);
      touchStartY = e.touches[0].clientY;
    }
  }

  function onScroll() {
    if (!fullyExpanded) window.scrollTo(0, 0);
  }

  /* Keyboard access: down-keys advance (complete on second press),
     up-keys collapse once back at the top. */
  function onKey(e) {
    var target = e.target;
    if (target && /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName)) return;
    var forward = ['ArrowDown', 'PageDown', ' ', 'Spacebar', 'End'].indexOf(e.key) !== -1;
    var backward = ['ArrowUp', 'PageUp', 'Home'].indexOf(e.key) !== -1;
    if (!fullyExpanded && forward) {
      e.preventDefault();
      updateProgress(progress < 0.6 ? 0.7 : 1);
    } else if (fullyExpanded && backward && window.scrollY <= 5) {
      setExpanded(false);
      updateProgress(0);
      e.preventDefault();
    }
  }

  window.addEventListener('wheel', onWheel, { passive: false });
  window.addEventListener('scroll', onScroll);
  window.addEventListener('keydown', onKey);
  window.addEventListener('touchstart', onTouchStart, { passive: false });
  window.addEventListener('touchmove', onTouchMove, { passive: false });
  window.addEventListener('touchend', function () {
    touchStartY = 0;
  });

  render();
})();
